export const DEFAULT_LANG = 'en';

export const DE = 'de';
export const EN = 'en';
export const FR = 'fr';
export const IT = 'it';
export const ES = 'es';
export const ES_MX = 'es_MX';
